package ai.jessie.web.pages

import ai.jessie.web.onboarding.LocalOnboardingPort
import ai.jessie.web.onboarding.OnboardingState
import ai.jessie.web.onboarding.followEntry
import ai.jessie.web.onboarding.onboardingForm
import ai.jessie.web.theme.entryFrame
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.isExporting

@Page
@Composable
fun onboardingPage() {
    val port = LocalOnboardingPort.current
    val scope = rememberCoroutineScope()
    val model = remember(port, scope) { OnboardingState(port, scope) }
    LaunchedEffect(model) { if (!AppGlobals.isExporting) model.refresh() }
    followEntry(model.state.entry) { "/organisations/$it?home=onboarding" }
    entryFrame("Willkommen bei Jessie", model.state.error?.authenticationRequired == true) {
        onboardingForm(model.state, model.actions)
    }
}
